import React from 'react';

interface StepperProps {
  currentStep: number;
  steps: Array<{
    number: number;
    label: string;
  }>;
}

export function Stepper({ currentStep, steps }: StepperProps) {
  return (
    <div className="flex items-center justify-center gap-4 mb-8">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className={`flex items-center gap-2 ${currentStep === step.number ? 'font-bold text-primary' : 'text-gray-400'}`}>
            {step.number} <span className="hidden sm:inline">{step.label}</span>
          </div>
          {index < steps.length - 1 && (
            <div className="w-8 h-0.5 bg-gray-200" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
} 